import {
  Card,
  Button,
  CardBody,
  CardHeader,
  Col,
  Row,
  Input,
  FormGroup,
} from "reactstrap";
import { SelectPicker } from "rsuite";
import { Field, Module } from "../../../types/TenantInterfaces";
import { useMemo } from "react";
import WidgetSection from "./WidgetSection";

interface Props {
  section: any;
  index: number;
  reorderSection: any;
  sectionsLength: number;
  editMode: boolean;
  removeSection: any;
  infoChange: any;
  currentModule: Module;
}

const RichTextSection = ({
  section,
  index,
  reorderSection,
  sectionsLength,
  editMode,
  removeSection,
  infoChange,
  currentModule,
}: Props) => {
  const richTextFieldOptions = useMemo(() => {
    const options = currentModule?.Fields.filter(
      (field: Field) => field.FieldType === "RichText"
    );
    return options;
  }, [currentModule]);

  return (
    <WidgetSection
      editMode={editMode}
      reorderSection={reorderSection}
      section={section}
      index={index}
      sectionsLength={sectionsLength}
      removeSection={removeSection}
      infoChange={infoChange}
      body={
        <>
          <h5 className="text-uppercase">Rich Text Field</h5>
          <div>
            {editMode ? (
              <div className="mt-4">
                <div className="mt-4">
                  <SelectPicker
                    placeholder="Select Rich Text Field"
                    data={richTextFieldOptions}
                    labelKey="Name"
                    valueKey="APIName"
                    value={section.Field}
                    block
                    preventOverflow
                    onSelect={(e, f) => {
                      infoChange(e, section);
                    }}
                  />
                </div>
              </div>
            ) : (
              <Row>
                {section.Fields.map((field: any, i: number) => (
                  <Col xs="12" sm="12" md="6" key={i}>
                    <Card className="mt-3 mb-0 border shadow-none">
                      <CardBody className="p-2">
                        <h4 className="mb-0">{field.Field.Name}</h4>
                        <p
                          className="mb-0 text-muted"
                          style={{
                            lineHeight: 1.25,
                          }}
                        >
                          <small>{field.Field.APIName}</small>
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            )}
          </div>
        </>
      }
    />
  );
};

export default RichTextSection;
